module.exports = __webpack_public_path__ + "0b88bc0bd091669dee60aea705177168.pdf";